if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}

// Custom code for "Read More" functionality
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.rich-text-container').forEach(function(container) {
    var readMoreLink = container.querySelector('.read-more-link');
    var richTextContent = container.querySelector('.rich-text-content');
    var readMoreText = readMoreLink.textContent;
    var readLessText = readMoreLink.getAttribute('data-read-less-text');
    var originalMaxHeight = richTextContent.style.maxHeight;

    if (readMoreLink && richTextContent) {
      readMoreLink.addEventListener('click', function(event) {
        event.preventDefault();
        container.classList.toggle('expanded');
        if (container.classList.contains('expanded')) {
          readMoreLink.textContent = readLessText;
          richTextContent.style.maxHeight = 'none';
        } else {
          readMoreLink.textContent = readMoreText;
          richTextContent.style.maxHeight = originalMaxHeight;
          // Scroll to the read more link
          readMoreLink.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  });
});
